import { render } from "./mispadres.vue?vue&type=template&id=6b9f0866&scoped=true"
import script from "./mispadres.vue?vue&type=script&lang=js"
export * from "./mispadres.vue?vue&type=script&lang=js"

import "./mispadres.vue?vue&type=style&index=0&id=6b9f0866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9f0866"]])

export default __exports__